// @ts-strict-ignore
import { combineReducers } from 'redux';
import { TryUpdateStepRunsAction, UPDATE_STEP_RUNS } from '@/actions/stepRun';
import { StepRun } from '@/types/stepRun';

interface StepRunsById {
    [id: string]: StepRun;
}

type StepRunActionTypes = TryUpdateStepRunsAction;

export function pickLatestStepRun(current: StepRun | undefined, incoming: StepRun): StepRun {
    if (!current?.lastRenderedAt) {
        return incoming;
    }

    // Keep versioned state when an older server instance sends an update without a revision.
    if (!incoming.lastRenderedAt) {
        return current;
    }

    const currentLastRenderedAt = Date.parse(current.lastRenderedAt);
    if (Number.isNaN(currentLastRenderedAt)) {
        return incoming;
    }

    const incomingLastRenderedAt = Date.parse(incoming.lastRenderedAt);
    if (Number.isNaN(incomingLastRenderedAt)) {
        return current;
    }

    return incomingLastRenderedAt >= currentLastRenderedAt ? incoming : current;
}

function stepRunsById(state: StepRunsById = {}, action: StepRunActionTypes) {
    switch (action.type) {
        case UPDATE_STEP_RUNS: {
            const newState = {
                ...state,
            };
            const stepRuns = action.payload;
            for (const stepRun of stepRuns) {
                newState[stepRun.id] = pickLatestStepRun(state[stepRun.id], stepRun);
            }
            return newState;
        }

        default:
            return state;
    }
}

export const stepRunsReducer = combineReducers({
    byId: stepRunsById,
});
